// src/pages/Cart.js
import React, { useContext, useState } from "react";
import { ShopContext } from "../context/shop-context";
import {
  Button,
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { Link } from "react-router-dom";
const Cart = () => {
  const [message, setMessage] = useState(""); 
 // Format cart items into a WhatsApp message
  const formatCartItems = () => {
    let message = `Hello @Whimssical Stitches, I'm interested in purchasing the items below\n Order Summary:\n`;
    itemsArray.forEach((item) => {
      message += `- ${item.name} (Quantity: ${item.quantity}, Price: ${item.price})\n`;
    });
    message += `\nTotal: ksh${calculateTotalPrice()}\nKindly provide more details on these.`;
    return encodeURIComponent(message);
  };
  
// Apply 20% discount
  // const formatCartItems = () => {
  //   let message = `Hello @Whimssical Stitches, I'm interested in purchasing the items below\n Order Summary:\n`;
  //   itemsArray.forEach((item) => {
  //     const discountedPrice = (
  //       parseFloat(item.price.replace("ksh", "")) * 0.8
  //     ).toFixed(2); 
  //     message += `- ${item.name} (Quantity: ${item.quantity}, Discounted Price: ksh${discountedPrice})\n`;
  //   });
  //   message += `\nTotal: ksh${calculateTotalPrice()}\nKindly provide more details on these.`;
  //   return encodeURIComponent(message);
  // };

  // const calculateDiscountedPrice = (price) => {
  //   const numericPrice = parseFloat(price.replace("ksh", "").replace(",", ""));
  //   const discountedPrice = numericPrice * 0.8; // Apply 30% discount
  //   return `ksh ${discountedPrice.toFixed(2)}`;
  // };
  // Generate WhatsApp link
  const generateWhatsAppLink = () => {
    const whatsappNumber = "254114075312"; 
    const message = formatCartItems();
    return `https://wa.me/${whatsappNumber}?text=${message}`;
  };

  // Handle WhatsApp order
  const handlePayment = async () => {
    try {
      window.open(generateWhatsAppLink(), "_blank");
    } catch (error) {
      setMessage("Unable to send order.Kindly try again.");
    }
  };
  const { cartItems, updateItemQuantity, removeItem } = useContext(ShopContext); 
  // Convert cartItems object to an array of items
  const itemsArray = Object.values(cartItems); 
  // Calculate total price of all items in the cart
  const calculateTotalPrice = () =>
    itemsArray
      .reduce(
        (sum, item) =>
          sum + item.quantity * parseFloat(item.price.replace("ksh", "")),
        0
      )
      .toFixed(2);
  const totalItems = itemsArray.reduce((sum, item) => sum + item.quantity, 0);
  return (
    <Box sx={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Cart ({totalItems} items)
      </Typography>
      {itemsArray.length === 0 ? (
        <Typography>
          Your cart is empty. <Link to="/shop">Continue shopping</Link>
        </Typography>
      ) : (
        <Box>
          {itemsArray.map((item) => (
            <Card
              key={item.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                alignItems: "center",
              }}
            >
              <CardMedia
                component="img"
                image={item.image}
                alt={item.name}
                sx={{ width: 100, height: 100, objectFit: "contain" }}
              />

              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
                >
                  <Typography variant="h6">{item.name}</Typography>{" "}
                  <Typography variant="body2">Price: {item.price}</Typography>
                  <Typography variant="body2">
                    Total: ksh 
                    {(
                      item.quantity * parseFloat(item.price.replace("ksh", ""))
                    ).toFixed(2)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Button
                    onClick={() =>
                      updateItemQuantity(item.id, item.quantity - 1)
                    }
                    disabled={item.quantity <= 1}
                  >
                    -
                  </Button>

                  <Typography display="inline" sx={{ mx: 2 }}>
                    {item.quantity}
                  </Typography>

                  <Button
                    onClick={() =>
                      updateItemQuantity(item.id, item.quantity + 1)
                    }
                  >
                    +
                  </Button>

                  <Button onClick={() => removeItem(item.id)} sx={{ ml: 2 }}>
                    Remove
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}

          <Box sx={{ marginTop: "20px", textAlign: "right" }}>
            <Typography variant="h5">
              Total Price: ksh {calculateTotalPrice()}
            </Typography>
          </Box>
          <Box sx={{marginTop: '20px',textAlign: 'right'}}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={handlePayment} 
              sx={{
                backgroundColor:'#1c0a49',
                '&:hover':{backgroundColor:'#cb6ce6',
                },
                }}
            >
              Order Now
            </Button>
            {message && <Typography>{message}</Typography>}
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default Cart;
